const InputModal = ({
  title,
  description,
  value,
  setValue,
  onConfirm,
  onCancel,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  requireInput = true,
  error
}) =>
<div className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 p-4 backdrop-blur">
    <div className="glass-panel w-full max-w-md rounded-2xl p-5">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-semibold text-textMuted">Action</p>
          <h3 className="text-lg font-semibold text-white m-0">{title}</h3>
        </div>
      </div>
      {description ? <p className="mt-2 text-sm text-textMuted">{description}</p> : null}
      {requireInput ?
    <input
      className="mt-3 w-full rounded-lg border border-border bg-inset/70 px-3 py-2 text-sm text-white placeholder:text-textMuted focus:border-accent focus:outline-none"
      value={value}
      autoFocus
      onChange={(e) => setValue(e.target.value)} /> :

    null}
      {error ? <p className="mt-2 text-sm text-red-300">{error}</p> : null}
      <div className="mt-4 flex justify-end gap-2">
        <button type="button" className="ghost-button" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button
        type="button"
        className="pill-button px-4 py-2"
        onClick={() => {
          if (requireInput && !value) return;
          onConfirm(value);
        }}>
        
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>;


export default InputModal;